// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".choice[data-v-4dc3544a] {\n  display: flex;\n}\n.choice .tags[data-v-4dc3544a] {\n  min-width: 300px;\n  min-height: 32px;\n  margin-left: 30px;\n  border: 1px solid #d7d7d7;\n  padding: 0 10px 0 0;\n  border-radius: 6px;\n}\n.choice .tags .el-tag[data-v-4dc3544a] {\n  margin-left: 10px;\n}\n.choice .tags.is-disabled[data-v-4dc3544a] {\n  background-color: #f5f7fa;\n  border-color: #e4e7ed;\n  color: #c0c4cc;\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
